import React from "react";

const StockAssistantIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#667085"
      className="size-6"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 8h5m-5 4h3M12 3.75c-4.97 0-9 3.29-9 7.35 0 1.93.89 3.73 2.44 5.09l-.94 3.89 4.12-2.06c1.04.27 2.15.4 3.38.4 1.61 0 3.13-.3 4.45-.83"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 14l2 2-4 4-2-2m0 0l-1.5-1.5m1.5 1.5l4-4"
      />
    </svg>
  );
};

export default StockAssistantIcon;
